/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Emailtemplate_Outreachtitle3Inputs */

const en_coinvestments_emailtemplate_outreachtitle3 = /** @type {(inputs: Coinvestments_Emailtemplate_Outreachtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outreach email`)
};

/**
* | output |
* | --- |
* | "Outreach email" |
*
* @param {Coinvestments_Emailtemplate_Outreachtitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_emailtemplate_outreachtitle3 = /** @type {((inputs?: Coinvestments_Emailtemplate_Outreachtitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Emailtemplate_Outreachtitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_emailtemplate_outreachtitle3(inputs)
});
export { coinvestments_emailtemplate_outreachtitle3 as "coInvestments_emailTemplate_outreachTitle" }